import React, { useState, useEffect } from "react";
import { Select, Radio } from "antd";
import "./EditUserRoles.scss";
import * as API from "utils/api";

export default function EditUserRoles({ user_id }) {
  const [GetRoles, setGetRoles] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  useEffect(() => {
    if (user_id) {
      API.GetUserRoles(user_id).then((roles) => {
        if (roles.user_roles.roles) {
          setSelectedValues(roles.user_roles.roles.map((role) => role.id));
        }
      });
    }
    if (GetRoles.length < 1) {
      API.getNurseRoles().then((res) => {
        setGetRoles(res.roles);
      });
    }
  }, [user_id]);
  const { Option } = Select;
  const children = [];
  for (let i = 0; i < GetRoles.length; i++) {
    children.push(
      <Option key={i.toString(36) + i} value={GetRoles[i].id}>
        {GetRoles[i].name}
      </Option>
    );
  }

  function handleChange(value) {
    console.log(`Selected: ${value}`);
    setSelectedValues(value);
    console.log(selectedValues, "select");
  }
  const onDeselect = (role_id, secParam, third) => {
    let roles = selectedValues.filter((id) => id != role_id);
    setSelectedValues([...roles]);
    API.DeleteRoles(user_id, role_id);
  };
  const onSelect = (role_id) => {
    let roles = [...selectedValues];
    let role = GetRoles.find((role) => role.id === role_id);
    roles.push(role.id);
    API.AddRole(user_id, role_id).then((res) => {
      setSelectedValues([...roles]);
    });

    // API.DeleteRoles(user_id, role_id);
  };
  return (
    <div>
      <Select
        mode="multiple"
        value={selectedValues}
        onDeselect={onDeselect}
        placeholder="Please select"
        onSelect={onSelect}
        // onChange={OnRoleChange}
        style={{ width: "100%" }}
      >
        {children}
      </Select>
    </div>
  );
}
